import styled from 'styled-components'

export const Box = styled.div`
  ${({ theme: { colors } }) => `
  /* Fixed share of the row: content never grows the panel (min-* 0 overrides flex's auto minimum) */
  flex: 1 1 0;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid ${colors('text')};
  margin: 0 0.5rem;
  &:first-of-type {
    margin-left: 0;
  }
  &:last-of-type {
    margin-right: 0;
  }
    `}
`
